import React from 'react';
import {Link} from 'react-router-dom';
import db from "../../database";
import loading from "../../img/loading.svg";


export default class extends React.Component  {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      getResult: this.props.score,
    }
  }

  render() {
    const result = this.state.getResult;

    return (
      <div style={{"maxWidth": "400px", "margin": "auto", "text-align": "center"}}>
        <h3>Myth Buster Results</h3>
        <p>
          Well done! You have completed the quiz!
        </p>
        <h1>{result}/10</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Quiz/mythsResults.js